import { Redirect, Route } from "react-router-dom";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("access_token") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/auth/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

// Paths management viewers are allowed to access
const MANAGEMENT_VIEWER_ALLOWED_PATHS = ["/user/attendance", "/user/tasks"];

export const ProtectedRoute = ({
  component: Component,
  adminOnly,
  allowRoles,
  viewerRoleBlocked,
  isRedirect,
  path,
  ...rest
}) => (
  <Route
    {...rest}
    path={path}
    render={(props) => {
      if (!localStorage.getItem("access_token")) {
        return (
          <Redirect to={{ pathname: "/auth/login", state: { from: props.location } }} />
        );
      }

      const userRole = localStorage.getItem("user_role");
      const viewerRole = localStorage.getItem("viewer_role");

      if (adminOnly && userRole !== "admin") {
        return <Redirect to="/user/tasks" />;
      }

      if (allowRoles && allowRoles.length > 0 && !allowRoles.includes(userRole)) {
        return <Redirect to="/user/tasks" />;
      }

      // Management viewers can only access the Tasks list and Attendance.
      // Redirect-only pages (detail pages reached via in-app navigation) are exempt.
      if (
        viewerRole === "management" &&
        !isRedirect &&
        !MANAGEMENT_VIEWER_ALLOWED_PATHS.includes(path)
      ) {
        return <Redirect to="/user/tasks" />;
      }

      // Routes marked viewerRoleBlocked are hidden from ALL viewer roles
      if (viewerRoleBlocked && viewerRole) {
        return <Redirect to="/user/tasks" />;
      }

      return <Component {...props} />;
    }}
  />
);
